import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import GridContainer from './GridContainer';
import GridMetadata from './GridMetadata';
import GridMetadataTabState from './GridMetadataTabState';

export default class GridMetadataTabView extends BufferTabView<GridMetadataTabState> {
  static override initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override render(): GridMetadataTabView {
    renderToDOM(
      <GridContainer gridId={this.model.get('gridId')}>
        {(childProps) => <GridMetadata {...childProps} />}
      </GridContainer>,
      this.el
    );
    return this;
  }

  override remove(): GridMetadataTabView {
    ReactDOM.unmountComponentAtNode(this.el);
    super.remove();
    return this;
  }
}
